import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Pencil } from '../../static';
import Input from '../Input';
import { addAvatar } from '../../app/actions/appActions';
import { showAlert } from '../../app/actions/uiActions';

import './styles.scss';

const UserEdit = ({isEdit,isEditImg}) => {
	const dispatch = useDispatch();
	const userId = useSelector((state) => state.firebase.profile.userId);
	
	const handleChangeInput = (target) => {
		const file = target.files[0];

		if(file.type === 'image/png' || file.type === 'image/jpeg'){
			dispatch(addAvatar({file , userId}));
		} else {
			dispatch(showAlert({type: 'error', message: 'The file does not match the type'}));
		};
	};
	
	return (
		<div className="user__edit">
			{isEdit && ( 
				<>
					<Pencil />
					<span className="user__edit-text">
						Edit Profile Information
					</span>
				</>
			)}
			{isEditImg && (
				<Input 
					id='file'
					type='file' 
					label='Edit Profile Image'
					onChange={handleChangeInput}
				/>
			)}
		</div>
	);
};

export default UserEdit;
